import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CalendarOptions } from '@fullcalendar/angular';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ToastrService } from 'ngx-toastr';
import { AcademicsServiceService } from 'src/app/academics-service.service';

@Component({
  selector: 'add-edit-calendar-master',
  templateUrl: './add-edit-calendar-master.component.html',
  styleUrls: ['./add-edit-calendar-master.component.css'],
  providers: [DatePipe]
})
export class AddEditCalendarMasterComponent implements OnInit {
  @Input() calendardata:any;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  ID?:string;
  Category?:string;
  Title?:string;
  Description?:string;
  StartDate?:string;
  EndDate?:string;
  Images?:string;
  UserName?:string;
  Active?:Boolean;
  status ?: string;
  
  public message: string;
  public imagePath;
  imgURL: any;
  imgURL1: any;
  selectedFile;
  calendarOptions: CalendarOptions;
  catList: any = ['Event', 'Exam', 'Holiday']
catName: any;

activeList: any = ['Y', 'N']
actName: any;
  constructor(private service: AcademicsServiceService,private imageCompress: NgxImageCompressService,private datePipe: DatePipe,private toastr: ToastrService) { }

  ngOnInit(): void {
   

    this.ID=this.calendardata.ID;
    this.Title=this.calendardata.Title;
    this.Category=this.calendardata.Category;
    this.Description=this.calendardata.Description;
    
    this.StartDate= this.datePipe.transform(this.calendardata.StartDate, 'yyyy-MM-dd');
     this.EndDate= this.datePipe.transform(this.calendardata.EndDate, 'yyyy-MM-dd');
     this.Images = "data:image/png;base64,"+ this.calendardata.Images
     this.UserName=this.calendardata.UserName;
    this.Active=this.calendardata.Active;
    
  }
   changeCategory(e) {
    this.catName=e.target.value
      onlySelf: true
    
    
    
  }

  changeActive(e) {
    this.actName=e.target.value
      onlySelf: true
    
  }

  
   
    onFileChanged(event) {
    
    this.selectedFile = event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = () => {
        console.log(reader.result);
        this.imgURL=reader.result;


        this.imageCompress.compressFile(this.imgURL, 0, 75, 50).then(
          result => {
            console.log(result);
            //this.imgResultAfterCompress = result;
            this.Images=result;
            console.warn('Size in bytes is now:', this.imageCompress.byteCount(result));
          }
        );
        //this.SchoolLogo=this.imgURL;
       
    };
  } 


  addCalendarData(){
  
    var val = {ID:this.ID,
    Category:this.Category,
    Title:this.Title,
    Description:this.Description,
    StartDate:this.StartDate,
    EndDate:this.EndDate,
    Images:this.Images.split(',')[1],
    UserName:this.UserName,
    Active:this.Active
   

        
  };
 
    this.service.addCalendarData(val).subscribe(res=>{
      //alert(res.toString());

      this.onModalClose();
      this.showSuccess();
    });
    }
    

    updateCalendarData(){
     
 
     var val = {ID:this.ID,
       Category:this.Category,
       Title:this.Title,
       Description:this.Description,
       StartDate:this.StartDate,
    EndDate:this.EndDate,
    Images:this.Images.split(',')[1],
    UserName:this.UserName,
    Active:this.Active
    
               
      };
    
        this.service.updateCalendarData(val).subscribe(res=>{
          this.onModalClose();
          this.showUpdate();
        });
    }

    onModalClose(): void {
      
      //angular.element('.inmodal').hide();
      this.close.emit();
      
    }

    showSuccess() {
      this.toastr.success('Save Successfully.', '');
   
    }

    showUpdate() {
      this.toastr.success('Update Successfully.', '');
   
    }
}
